import {
  Flex,
  Text,
  useMediaQuery,
  ListItem,
  UnorderedList,
  Heading,
} from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import AtracoesCarousel from "ui/components/AtracoesCarousel";
import EstruturaImagesContent from "../../../components/EstruturaImagesContent";
import OutlineButton from "ui/components/Button/OutlineButton";
import { BiChevronLeft } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

export default function ParqueAquatico() {
  const navigate = useNavigate();
  const [isLargerThan800] = useMediaQuery("(min-width: 800px)");
  return (
    <Flex
      py={["150px", "150px", "150px", "350px"]}
      px={["50px", "50px", "30px", "200px"]}
      gap="40px"
      flexDir={"column"}
    >
      <Flex flexDir={"column"} pt="20px" gap={10} w="100%">
        <Heading
          variant={"superCellMagic"}
          fontWeight="medium"
          fontSize="24px"
          color={colors.newBlue}
          flexWrap="wrap"
        >
          PARQUE AQUÁTICO
        </Heading>
        <Text fontSize="16px" fontWeight="bold" color={colors.newBlue}>
          ÁCQUA PARK PANTANAL – Seu dia mais feliz começa aqui!
        </Text>
        <Text fontSize="16px">
          Imagine um lugar cercado por natureza, com águas refrescantes,
          atrações para todas as idades e aquele clima perfeito de férias… Esse
          lugar existe, e está <strong>a apenas 20 km de Cuiabá</strong>, no
          coração do cerrado mato-grossense!
        </Text>
        <Text fontSize="16px">
          O <strong>ÁCQUA PARK PANTANAL</strong> nasceu no meio da natureza,
          entre <strong>Chapada dos Guimarães e Cuiabá</strong>, numa área rica
          em paisagens, fauna, flora e solo com mais de 5 milhões de anos de
          história. Acesso fácil, por estrada{" "}
          <strong>duplicada e iluminada</strong> – do portão da cidade direto
          para o portão da alegria!
        </Text>
      </Flex>
      <Flex flexDir={"column"} pt="20px" gap={10} w="100%">
        <Heading
          variant="superCellMagic"
          fontWeight="medium"
          fontSize="24px"
          color={colors.newBlue}
          flexWrap="wrap"
        >
          ESTRUTURA COMPLETA PARA TODAS AS IDADES
        </Heading>
        <Text fontSize="16px">
          Aqui a diversão não tem limite! Nosso parque oferece uma estrutura
          pensada para encantar desde os aventureiros até os que querem apenas
          relaxar e curtir momentos especiais em família.
        </Text>
        <Heading
          variant={"superCellMagic"}
          color={colors.newBlue}
          fontSize="24px"
          fontWeight="bold"
        >
          ATRAÇÕES IMPERDÍVEIS:
        </Heading>
        <Text>
          <UnorderedList fontSize="16px">
            <ListItem>Piscina de Ondas – Sinta o mar de Mato Grosso!</ListItem>
            <ListItem>
              Cachoeira Véu de Noiva – Visual paradisíaco e queda refrescante
            </ListItem>
            <ListItem>
              Cachoeira Jabuti – Uma surpresa molhada na área infantil
            </ListItem>
            <ListItem>
              Acqualândia – O reino encantado da Serpente Marinha, com
              escorregadores em forma de animais e muita cor
            </ListItem>
            <ListItem>
              Piscina Oasis Semi Coberta – Tranquilidade e sombra na medida
              certa
            </ListItem>
            <ListItem> Bar Molhado – Refresque-se sem sair da água</ListItem>
            <ListItem>
              Trio de Toboáguas Radicais: Fantástico, Fabuloso e Magnífico –
              adrenalina em dose tripla!
            </ListItem>
          </UnorderedList>
        </Text>
      </Flex>

      <Flex flexDir={"column"} pt="20px" gap={10} w="100%">
        <Heading
          variant="superCellMagic"
          fontWeight="medium"
          fontSize="24px"
          color={colors.newBlue}
          flexWrap="wrap"
        >
          ESTACIONAMENTO GRATUITO
        </Heading>
        <Text fontSize="16px">
          Loja de moda praia com os últimos lançamentos
        </Text>
        <Text fontSize="16px"> Complexo gastronômico completo:</Text>
        <Text fontSize="16px">
          Restaurante, doceria, cafeteria, lanchonetes, confeitaria e bares com
          porções, comidas típicas, massas, peixes, carnes, lanches, doces,
          salgados e bebidas variadas!
        </Text>
      </Flex>

      <Flex flexDir={"column"} pt="20px" gap={10} w="100%">
        <Heading
          variant="superCellMagic"
          fontWeight="medium"
          fontSize="24px"
          color={colors.newBlue}
          flexWrap="wrap"
        >
          EVENTOS NO PARQUE
        </Heading>
        <Text fontSize="16px">
          Quer comemorar aqui? Nós temos o cenário perfeito!
        </Text>
        <Text fontSize="16px">
          Realizamos festas de aniversário, reuniões de grupos e
          confraternizações, tudo com estrutura completa:
        </Text>
        <Text>
          <UnorderedList fontSize="16px">
            <ListItem>Bangalôs privativos e camarotes</ListItem>
            <ListItem>Decoração temática</ListItem>
            <ListItem>Mesas, cadeiras e ambientes reservados</ListItem>
            <ListItem>Opção de buffet com bolos, doces e salgados</ListItem>
          </UnorderedList>
        </Text>
        <Text fontSize="16px">
          Você escolhe o motivo. A gente entrega o momento perfeito.
        </Text>
      </Flex>

      <Flex flexDir={"column"} pt="20px" gap={10} w="100%">
        <Heading
          variant="superCellMagic"
          fontWeight="medium"
          fontSize="24px"
          color={colors.newBlue}
          flexWrap="wrap"
        >
          SEGURANÇA É COISA SÉRIA
        </Heading>
        <Text fontSize="16px">
          Nosso parque conta com uma equipe especializada de guarda-vidas e
          monitores treinados, garantindo total segurança em todas as atrações,
          para que você possa curtir com tranquilidade.
        </Text>
      </Flex>

      <Flex flexDir={"column"} pt="20px" gap={10} w="100%">
        <Heading
          variant="superCellMagic"
          fontWeight="medium"
          fontSize="24px"
          color={colors.newBlue}
          flexWrap="wrap"
        >
          Diversão, aventura e MUITA água para toda a família!
        </Heading>
        <Text fontSize="16px">
          Venha viver o seu dia mais feliz no ÁCQUA PARK PANTANAL.
        </Text>
        <Text fontSize="16px">
          Porque aqui, todo mundo volta pra casa com o coração leve, a alma
          molhada e um sorriso no rosto!
        </Text>
      </Flex>

      <AtracoesCarousel />

      <Heading
        variant="superCellMagic"
        fontWeight="medium"
        fontSize="24px"
        color={colors.newBlue}
        flexWrap="wrap"
      >
        CONHEÇA NOSSA ESTRUTURA
      </Heading>
      <EstruturaImagesContent isLarger={isLargerThan800} qtdeFotos={30} />
      <OutlineButton
        w={`200px`}
        onClick={() => navigate("/")}
        title="VOLTAR"
        color={colors.blue}
        prevIcon={<BiChevronLeft size={20} />}
      />
    </Flex>
  );
}
